import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalTotalAgrupadoFormaPagamento } from '@/features/relatorio/page/fiscal/total-agrupado-forma-pagamento/RelatorioFiscalTotalAgrupadoFormaPagamento';

export const Route = createFileRoute('/a/relatorio/fiscal/total-agrupado-forma-pagamento')({
    component: RelatorioFiscalTotalAgrupadoFormaPagamento,
});
